import React, { Component } from "react";
import Card from "../components/Card";

export default class Experience extends Component {
  render() {
    return (
      <React.Fragment>
        <Card id="Experience" className="content" headerText="Experience">
          <table>
            <thead>
              <tr>
                <th>UX Developer</th>
                <th>Company: Pinewood Technologies</th>
                <th>January 2023 - Present</th>
              </tr>
            </thead>
            <tbody></tbody>
          </table>
          <table>
            <thead>
              <tr>
                <th>Web Developer</th>
                <th>Company: Digital By Default</th>
                <th>September 2019 - January 2023</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="3">
                  As a Web Developer at Digital By Default, I have transformed
                  my knowledge of website development into a passion and an area
                  of software engineering that I thoroughly enjoy. Projects I’ve
                  worked on: <br />
                  • Armac Martin – Being a Shopify based ecommerce website I
                  worked with my team to maintain the website and implement new
                  features, such as the restructuring of their current product
                  pages. Using Github to utilise version control.
                  <br />
                  • Frank Allart – Having both a website and an application. I
                  have been expanding my knowledge of React.js to develop their
                  mobile application while also working on their Laravel custom
                  built site to carry out site amends and add in new products{" "}
                  <br />
                  • Packington Free Range – Being a Wordpress Ecommerce store I
                  have maintained their custom-built theme by adding in new
                  product ranges and improving their current site navigation to
                  gain a better user experience. <br />
                </td>
              </tr>
            </tbody>
          </table>
          <table>
            <thead>
              <tr>
                <th>Web Developer</th>
                <th>Company: Alpha Geek Digital</th>
                <th>May 2020 - September 2020 </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="3">
                  Whilst on furlough I was employed by Alpha Geek Digital in
                  order to undertake a new challenge and gain valuable
                  experiences by working on new projects with a new set of
                  clients.
                  <br />
                  Projects I’ve worked on: <br />
                  • Project Doughnut – With a big Instagram following I worked
                  with ProjectD following the launch of their woocommerce site.
                  Using Elemntor pro to add in new features and publish new
                  product releases
                  <br />
                  • Eagle Cliff – Using theme builders I helped implement a quiz
                  on their landing page in order receive more valuable
                  customers. <br />
                </td>
              </tr>
            </tbody>
          </table>
        </Card>
      </React.Fragment>
    );
  }
}
